import CustomerIds from "../../../../domain/customer/CustomerIds";
import MailGroup   from "../../../../domain/mail/group/MailGroup";
import {
  ACTION_TYPE,
  AddAllMailGroupCustomerAction,
  AddMailGroupCustomerAction,
  MailGroupAction,
  RemoveMailGroupCustomerAction,
  SetMailGroupAction,
  SetMailGroupNameAction
}                  from "./MailGroupAction";

const reduceMailGroup = (action: SetMailGroupAction): MailGroup => action.mailGroup;
const reduceMailGroupName = (state: MailGroup, action: SetMailGroupNameAction): MailGroup => new MailGroup(state.id, action.mailGroupName, state.customerIds, state.trail);
const reduceAddMailGroupCustomer = (state: MailGroup, action: AddMailGroupCustomerAction): MailGroup => new MailGroup(state.id, state.name, state.customerIds.add(action.customerId), state.trail);
const reduceAddAllMailGroupCustomer = (state: MailGroup, action: AddAllMailGroupCustomerAction): MailGroup => new MailGroup(state.id, state.name, action.customerIds, state.trail);
const reduceRemoveMailGroupCustomer = (state: MailGroup, action: RemoveMailGroupCustomerAction): MailGroup => new MailGroup(state.id, state.name, state.customerIds.remove(action.customerId), state.trail);
const reduceRemoveAllMailGroupCustomer = (state: MailGroup): MailGroup => new MailGroup(state.id, state.name, new CustomerIds(), state.trail);

const mailGroupReducer = (state: MailGroup = new MailGroup(), action: MailGroupAction): MailGroup => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_GROUP:
      return reduceMailGroup(action as SetMailGroupAction);
    case ACTION_TYPE.SET_MAIL_GROUP_NAME:
      return reduceMailGroupName(state, action as SetMailGroupNameAction);
    case ACTION_TYPE.ADD_MAIL_GROUP_CUSTOMER:
      return reduceAddMailGroupCustomer(state, action as AddMailGroupCustomerAction);
    case ACTION_TYPE.ADD_ALL_MAIL_GROUP_CUSTOMER:
      return reduceAddAllMailGroupCustomer(state, action as AddAllMailGroupCustomerAction);
    case ACTION_TYPE.REMOVE_MAIL_GROUP_CUSTOMER:
      return reduceRemoveMailGroupCustomer(state, action as RemoveMailGroupCustomerAction);
    case ACTION_TYPE.REMOVE_ALL_MAIL_GROUP_CUSTOMER:
      return reduceRemoveAllMailGroupCustomer(state);
  }
};

export default mailGroupReducer;
